import React, { Component } from 'react';
import { AppContext } from "./AppContext.jsx";
import { LoadingIcon2 } from 'web-store-modules/packages/web-store-ui-library';
import LoadingIcon from './components/ui/image-components/LoadingIcon.jsx';
import { storeId } from '../../variables/Variables.js';
import { exhibitStoreId } from './utils/StoreConfigManager.js';
export default class AppLoadingIcon extends Component {
    render() {
        return this.context.showingLoadingIcon ? storeId === exhibitStoreId ? <LoadingIcon /> : <LoadingIcon2 /> : <React.Fragment />;
    }
}

AppLoadingIcon.contextType = AppContext;